export default __webpack_public_path__ + "static/media/card_left.13875326.png";